import React from 'react';
import { Box, Card, CardHeader, CardContent, CardActions, Stack, Grid, } from '@mui/material';
var DeliveryRequestItemsAndRequestDateDialogCard = function (_a) {
    var headerColumn = _a.headerColumn, columns = _a.columns, actionColumn = _a.actionColumn, requestItemWithRequestableQuantity = _a.requestItemWithRequestableQuantity;
    return (React.createElement(Card, { sx: { mb: 2 } },
        React.createElement(CardHeader, { title: headerColumn.render &&
                headerColumn.render(requestItemWithRequestableQuantity, 'row'), sx: {
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
                padding: '12px 16px',
                fontWeight: 600,
            } }),
        React.createElement(CardContent, null,
            React.createElement(Stack, { spacing: 1.5 }, columns.map(function (_a, index) {
                var title = _a.title, render = _a.render;
                return (React.createElement(Stack, { direction: "column", key: index },
                    React.createElement(Box, { sx: { typography: function (theme) { return theme.customTypography.body3; } } }, title),
                    React.createElement(Box, { sx: {
                            typography: function (theme) { return theme.customTypography.body2; },
                            fontWeight: 500,
                        } }, render && render(requestItemWithRequestableQuantity, 'row'))));
            }))),
        React.createElement(CardActions, { sx: {
                padding: '12px 16px',
                backgroundColor: function (theme) { return theme.customPalette.background.neutral; },
            } },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 4, sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'row',
                    } }, actionColumn.title),
                React.createElement(Grid, { item: true, xs: 8 }, actionColumn.render &&
                    actionColumn.render(requestItemWithRequestableQuantity, 'row'))))));
};
export default DeliveryRequestItemsAndRequestDateDialogCard;
